import { AbsenceTypeEnum, AbsenceViewModel } from '@/services/api/nswag/stapiclient_generated';

export interface AbsenceColor {
  VCalendarHighlightColor: string;
  VCalendarHighlightFillMode: string;
  VCalendarDotColor: string;
  BgColorClass: string;
  BorderClass: string;
}

export function getPublicHolidayColor() {
  return {
    VCalendarHighlightColor: 'blue',
    VCalendarHighlightFillMode: 'solid',
    BgColorClass: 'bg-blue-500',
  } as AbsenceColor;
}

function constructBorder(absenceViewModel: AbsenceViewModel, mainColor: string) {
  const approvalNeeded = absenceViewModel.absenceType.approvalNeeded;
  const isApproved = absenceViewModel.isApproved;
  const isApprovalDecided = absenceViewModel.isApprovalDecided;

  if (!approvalNeeded) {
    return 'border-b-4 ' + 'border-' + mainColor + '-500 hover:border-' + mainColor + '-400';
  } else {
    if (isApprovalDecided) {
      return isApproved ? 'border-b-4 border-green-500' : 'border-b-4 border-red-500';
    } else {
      return 'border-b-4 border-yellow-500';
    }
  }
}

function constructBg(absenceViewModel: AbsenceViewModel, mainColor: string) {
  const approvalNeeded = absenceViewModel.absenceType.approvalNeeded;
  const isApprovalDecided = absenceViewModel.isApprovalDecided;

  if (!approvalNeeded) {
    return 'bg-' + mainColor + '-500 hover:bg-' + mainColor + '-400';
  } else {
    if (isApprovalDecided) {
      return 'bg-' + mainColor + '-500 hover:bg-' + mainColor + '-400';
    } else {
      return 'bg-' + mainColor + '-200 hover:bg-' + mainColor + '-100';
    }
  }
}

export function getAbsenceColor(absenceViewModel: AbsenceViewModel) {
  let res = {} as AbsenceColor;

  const approvalNeeded = absenceViewModel.absenceType.approvalNeeded;
  const isApproved = absenceViewModel.isApproved;
  const isApprovalDecided = absenceViewModel.isApprovalDecided;
  const type = absenceViewModel.absenceType.absenceTypeEnum;

  if (!approvalNeeded) {
    res.VCalendarHighlightFillMode = 'solid';
  } else {
    if (isApprovalDecided) {
      res.VCalendarHighlightFillMode = absenceViewModel.isHalfDay ? 'outline' : 'solid';
      res.VCalendarDotColor = isApproved ? 'green' : 'red';
    } else {
      res.VCalendarHighlightFillMode = 'light';
      res.VCalendarDotColor = 'orange';
    }
  }

  switch (type) {
    case AbsenceTypeEnum.Vacation:
      res.VCalendarHighlightColor = 'green';
      res.BgColorClass = constructBg(absenceViewModel, 'green');
      res.BorderClass = constructBorder(absenceViewModel, 'green');
      break;
    case AbsenceTypeEnum.Overtime:
      res.VCalendarHighlightColor = 'teal';
      res.BgColorClass = constructBg(absenceViewModel, 'teal');
      res.BorderClass = constructBorder(absenceViewModel, 'teal');
      break;
    case AbsenceTypeEnum.Sick:
      res.VCalendarHighlightColor = 'purple';
      res.BgColorClass = constructBg(absenceViewModel, 'purple');
      res.BorderClass = constructBorder(absenceViewModel, 'purple');
      break;
    case AbsenceTypeEnum.Other:
      res.VCalendarHighlightColor = 'pink';
      res.BgColorClass = constructBg(absenceViewModel, 'pink');
      res.BorderClass = constructBorder(absenceViewModel, 'pink');
      break;
  }

  return res;
}
